import axiosInstance from '../axios/axios-instance';

export const click = {
  /**
   * Checks if a click is terminated based on signed tile details.
   *
   * @param tileDetailsDto - Tile metadata string
   * @param tileDetailsSignature - Signature verifying the tileDetailsDto
   * @returns True if the click is terminated, false otherwise
   */
  async hasClickTerminated(tileDetailsDto: string, tileDetailsSignature: string): Promise<boolean> {
    const response = await axiosInstance.post<boolean>('/click/has-click-terminated', {
      tileDetailsDto: tileDetailsDto,
      tileDetailsSignature: tileDetailsSignature,
    });
    return response.data;
  },

  /**
   * Submits a user rating for a tile interaction if within valid range (1–5).
   *
   * @param tileDetailsDto - Tile metadata string
   * @param tileDetailsSignature - Signature verifying tileDetailsDto
   * @param rating - User rating between 1 and 5
   */
  async submitUserRating(tileDetailsDto: string, tileDetailsSignature: string, rating: number): Promise<void> {
    if (rating < 1 || rating > 5) {
      return;
    }
    await axiosInstance.post('/click/user-rating', {
      tileDetailsDto: tileDetailsDto,
      tileDetailsSignature: tileDetailsSignature,
      rating: rating,
    });
  },
};
